import React from 'react'

const StyledButton = ({ children, onClick, width, disabled, height, modal,student }) => {
  const buttonStyles = {
    backgroundColor: disabled ? '#ccc' : '#3C45FF',
    color: '#fff',
    borderRadius: student ? '16px' : '12px',
    padding: student ? '18px 56px' : modal ? '18px 24px' : '10px 16px',
    cursor: 'pointer',
    border: 'none',
    outline: 'none',
    width: width ? width : '100%',
    fontSize: '16px',
    fontWeight: 500,
    height: height ? height : 'auto',
    whiteSpace: 'nowrap',
    alignSelf: 'stretch',
  }

  return (
    <button style={buttonStyles} onClick={onClick} type="button" disabled={disabled}>
      {children}
    </button>
  )
}

export default StyledButton
